import { methodAllowsRequestBody } from '../../proxy/prepare-local-proxy-request-headers.js';
import { sendWsMessage } from '../../../connection/create-ws-bridge.js';
import { proxyToLocal } from '../../proxy/local-proxy.js';
import type { FirehoseMessageHandler } from '../firehose-message-router.js';

export const handleProxyMessage: FirehoseMessageHandler = (msg, deps) => {
  const proxy = msg.proxy;
  if (!proxy || typeof proxy !== 'object') return;

  const pr = proxy as {
    id: string;
    method: string;
    url: string;
    headers?: Record<string, string>;
    bodyLength?: number;
    streamResponse?: boolean;
    machineId?: string;
  };

  if (pr.streamResponse) {
    const bodyLength = methodAllowsRequestBody(pr.method) ? (pr.bodyLength ?? 0) : 0;
    const streamingRequest = {
      id: pr.id,
      method: pr.method,
      url: pr.url,
      headers: pr.headers,
      streamResponse: true as const,
    };

    if (bodyLength > 0) {
      const earlyBody = deps.earlyProxyBinaryBody.get(pr.id);
      if (earlyBody !== undefined) {
        deps.earlyProxyBinaryBody.delete(pr.id);
        deps.startStreamingProxy({
          ...streamingRequest,
          body: earlyBody.length > 0 ? earlyBody : undefined,
        });
      } else {
        deps.pendingProxyBody.set(pr.id, { pr: streamingRequest });
      }
    } else {
      deps.startStreamingProxy(streamingRequest);
    }
    return;
  }

  void proxyToLocal(pr)
    .then((res) => {
      if (res.error) deps.log(`[Proxy and log service] Preview proxy failed: ${res.error}`);
      sendWsMessage(deps.ws, { type: 'proxy_result', ...res, id: pr.id });
    })
    .catch((err) => {
      deps.log(
        `[Proxy and log service] Preview proxy failed: ${err instanceof Error ? err.message : String(err)}`,
      );
      sendWsMessage(deps.ws, { type: 'proxy_result', id: pr.id, error: String(err) });
    });
};
